import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardContent, CardHeader, CardTitle } from "../../tailwind/card";
import { useInvoice } from "../../../hooks/useInvoice";
import { transformPlans } from "../../../utils/planUtils";
import { mapCapabilityPlanIdToName } from "../../../utils/capabilityPlanUtils";
import { getPlanIds } from "../../../utils/capabilitiesHelper";
import { LoadingState } from "./components/LoadingState";
import { SubscriptionBanner } from "./components/SubscriptionBanner";
import { InvoiceTable } from "./components/InvoiceTable";

export const HistorySection = ({ invoices, isLoading, subscriptionStatus, hasPlanId, onPayInvoice }) => {
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(null);
  const {
    isDownloading,
    downloadSuccess,
    downloadUrl,
    triggerInvoiceDownload,
    downloadInvoicePdf,
    resetDownload,
  } = useInvoice();

  useEffect(() => {
    if (downloadSuccess && downloadUrl) {
      downloadInvoicePdf();
      setDownloadingInvoiceId(null);
      resetDownload();
    }
  }, [downloadSuccess, downloadUrl, downloadInvoicePdf, resetDownload]);

  const capabilities = useSelector((state) => state.capabilities.capabilities);
  const planIds = getPlanIds(capabilities);
  const activePlanId = planIds.length > 0 ? planIds[0] : null;

  const billingPlans = useSelector((state) => state.billing.plans);
  const transformedPlans = transformPlans(billingPlans || []);
  const activeCapabilitiesPlan = transformedPlans.find((plan) => plan.id === activePlanId);
  const activePlanName = activeCapabilitiesPlan?.name || mapCapabilityPlanIdToName(activePlanId) || "Unknown plan";

  const handleDownloadClick = (invoice) => {
    setDownloadingInvoiceId(invoice.id);
    triggerInvoiceDownload({
      companyId: invoice.companyId,
      invoiceId: invoice.invoiceId,
    });
  };

  return (
    <div className="space-y-6">
      {/* Subscription Banner */}
      {hasPlanId && (
        <SubscriptionBanner subscriptionStatus={subscriptionStatus} planName={activePlanName} />
      )}

      {/* Invoices Card */}
      <Card className="shadow-sm border-gray-200 dark:border-gray-700">
        <CardHeader className="pb-3">
          <CardTitle className="text-xl">Invoices</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <LoadingState />
          ) : (
            <InvoiceTable
              invoices={invoices}
              isDownloading={isDownloading}
              downloadingInvoiceId={downloadingInvoiceId}
              onDownload={handleDownloadClick}
              onPay={onPayInvoice}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
};
